import { SESSION_ID_HEADER } from './consts'

export const isLogoutUrl = (url = '') => /\/?logout$/.test(url)

export function syncSessionIdFromResponse (response, storage = sessionStorage) {
  if (isLogoutUrl(response.config.url)) {
    storage.removeItem('id')
    return
  }
  if (response.headers[SESSION_ID_HEADER] && !storage.getItem('id')) {
    storage.setItem('id', response.headers[SESSION_ID_HEADER])
  }
}
